import React from 'react';
import '../styles/LoadingSkeleton.css';

const LoadingSkeleton = ({ type = 'card', width = '100%', height = '20px', count = 1 }) => {
  const skeletons = Array.from({ length: count }, (_, index) => (
    <div key={index} className={`skeleton skeleton-${type}`} style={{ width, height }}>
      <div className="skeleton-shimmer"></div>
    </div>
  ));

  return count === 1 ? skeletons[0] : <div className="skeleton-group">{skeletons}</div>;
};

// Specific skeleton for stat cards
export const StatCardSkeleton = () => (
  <div className="stat-card stat-card-loading">
    <div className="skeleton-content">
      <div className="skeleton skeleton-line stat-label-skeleton">
        <div className="skeleton-shimmer"></div>
      </div>
      <div className="skeleton skeleton-line stat-value-skeleton">
        <div className="skeleton-shimmer"></div>
      </div>
    </div>
  </div>
);

// Specific skeleton for table rows
export const TableRowSkeleton = ({ columns = 4 }) => (
  <tr className="skeleton-table-row">
    {Array.from({ length: columns }, (_, index) => (
      <td key={index}>
        <div className="skeleton skeleton-line" style={{ width: '90%', height: '16px' }}>
          <div className="skeleton-shimmer"></div>
        </div>
      </td>
    ))}
  </tr>
);

export default LoadingSkeleton; 